interface MutableRef<T> { current: T }

export interface TrackingRuntimeRefs {
  watch: MutableRef<number | null>;
  marker: MutableRef<{ remove(): void } | null>;
  followAnchor: MutableRef<{ x: number; y: number } | null>;
  updateFuelHistogram: MutableRef<() => void>;
}

export function cleanupTrackingRuntime(refs: TrackingRuntimeRefs, clearWatch: (watchId: number) => void) {
  if (refs.watch.current !== null) clearWatch(refs.watch.current);
  refs.watch.current = null;
  refs.marker.current?.remove();
  refs.marker.current = null;
  refs.followAnchor.current = null;
  refs.updateFuelHistogram.current = () => undefined;
}
